import { EmailEditor } from "@consultants/consultant-profile-new/email-editor/email-editor";
import { EmailEditorFormValues } from "@consultants/consultant-profile-new/email-editor/form-values";
import { UseFormReturn } from "react-hook-form";

type Props = {
  form: UseFormReturn<EmailEditorFormValues, any, EmailEditorFormValues>;
};

export const EmailAction = (props: Props) => {
  return <EmailEditor {...props} disabledFields={{ recipients: true }} />;
};
